import React from "react"
import Select, { GroupBase } from "react-select"
import { SelectContainer } from ".."
import { setDefaults } from "../../helpers"
import { SearchableSelectProps } from "../../types"

const SearchableSelect = <
  OptionType,
  IsMulti extends boolean = false,
  Group extends GroupBase<OptionType> = GroupBase<OptionType>
>(
  props: SearchableSelectProps<OptionType, IsMulti, Group>
) => {
  const newProps = setDefaults(props)

  return (
    <SelectContainer
      id={newProps.id}
      name={newProps.name}
      hint={newProps.hint}
      error={newProps.error}
      noValidation={newProps.noValidation}
    >
      <Select {...newProps} />
      {newProps.children}
    </SelectContainer>
  )
}

export default SearchableSelect
